import React from 'react';
import { ArrowLeft, UserCog } from 'lucide-react';
import { toast } from 'sonner';

export default function ImpersonationBar({ user }) {
  const isImpersonating = localStorage.getItem('isImpersonating') === 'true';
  
  if (!isImpersonating) return null;

  const handleReturnToAdmin = () => {
    // Restore admin session
    const adminToken = localStorage.getItem('adminToken');
    const adminUser = localStorage.getItem('adminUser');
    
    if (adminToken && adminUser) {
      localStorage.setItem('token', adminToken);
      localStorage.setItem('user', adminUser);
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      localStorage.removeItem('isImpersonating');
      
      toast.success('Sesión de administrador restaurada');
      window.location.href = '/admin/users';
    } else {
      // Fallback: just logout
      localStorage.clear();
      window.location.href = '/login';
    }
  };

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between sticky top-0 z-50 shadow-md">
      <div className="flex items-center gap-2">
        <UserCog className="w-5 h-5" />
        <span className="text-sm font-medium">
          Estás viendo como: <strong>{user?.name}</strong> ({user?.role})
        </span>
      </div>
      <button
        onClick={handleReturnToAdmin}
        className="flex items-center gap-2 px-4 py-1.5 bg-white text-amber-600 rounded-lg font-medium text-sm hover:bg-amber-50 transition-colors"
      >
        <ArrowLeft className="w-4 h-4" />
        Volver al Admin
      </button>
    </div>
  );
}
